import TToasts from "./TToasts.vue";

export default TToasts;
